import React, { useEffect, useState } from 'react';
import { SIGNUP_MODE } from 'constants/auth';
import styled from 'styled-components';

import TrackingAPI from '../../../api/TrackingAPI';
import AuthForm from '../../auth/tools/AuthForm';
import NiceModal from '../../modals/NiceModal';

export default function SignupDialogOverlayTool(props) {
  const [isTracked, setIsTracked] = useState(false);

  const analyticsData = {
    intent: 'unlock_chat',
    ...props
  };

  useEffect(() => {
    if (isTracked) {
      return;
    }
    TrackingAPI.trackEvent('signup_panel_rendered', analyticsData);
    setIsTracked(true);
  }, []);

  return (
    <NiceModal onClose={props.onClose}>
      <ModalInnerPlaceholder>
        <AuthForm mode={SIGNUP_MODE} onClose={props.onClose} intent={'unlock_chat'} />
      </ModalInnerPlaceholder>
    </NiceModal>
  );
}

const ModalInnerPlaceholder = styled.div`
  width: 380px;
  padding: 24px;
  box-sizing: border-box;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
